export const AVAILABILITY_SCOPE_LIMIT = 3000;

export const hasReachedLimit = (scope: number) => scope > AVAILABILITY_SCOPE_LIMIT;
